import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const updateTaskGroup = async (model: IUnitTaskGroupModel): Promise<IUnitTaskGroupModel> =>
  axios.post(`/management/UnitProgramTask/UpdateTaskGroup`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
}

export const useManagementUpdateTaskGroup = (notify?: boolean, onSuccess?: (data: IUnitTaskGroupModel) => void) =>
  useMutation({
    mutationKey: ['updateTaskGroup'],
    mutationFn: ({ model }: Props) => updateTaskGroup(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated task.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update task.')
      }
    },
    throwOnError: false
  })
